//@ts-ignore
import CircleProgress from "js-circle-progress";

class CountUpCarousel extends elementorModules.frontend.handlers.Base {
  protected swiperInstance: any = null;

  constructor($element: JQuery, args: any) {
    console.log("CountUpCarousel run");
    super($element, args);
    const asyncSwiper = elementorFrontend.utils.swiper;
    const swiperElement = this.elements.$swiperContainer;

    document.querySelectorAll(".progress-ring").forEach((ring) => {
      const percent = Math.min(
        parseFloat(ring.getAttribute("data-percent")) || 0,
        100
      );

      // Calculate progress ring properties
      const circle = ring.querySelector(".progress-ring__circle") as SVGElement;
      const radius = 45;
      const circumference = 2 * Math.PI * radius;
      const offset = circumference - (percent / 100) * circumference;

      // Set progress ring properties
      circle.style.strokeDasharray = `${circumference} ${circumference}`;
      circle.style.strokeDashoffset = offset.toString();
    });

    const swiperConfig = {
      slidesPerView: 1.2,
      spaceBetween: 16,
      centeredSlides: true,
      roundLengths: true,
      loop: true,
      loopAdditionalSlides: 10,
      grabCursor: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: true,
      },
      pagination: {
        el: this.elements.$pagination[0],
        type: "bullets",
        clickable: true,
      },
      breakpoints: {
        768: { slidesPerView: 2, spaceBetween: 16 },
        1301: { slidesPerView: 3, spaceBetween: 24 },
        1501: { slidesPerView: 4, spaceBetween: 24 },

        2001: { slidesPerView: 5, spaceBetween: 24 },
      },
    };
    new asyncSwiper(swiperElement, swiperConfig).then((swiper: any) => {
      this.swiperInstance = swiper;
    });
  }

  getDefaultSettings() {
    return {
      selectors: {
        swiperContainer: ".swiper",
        swiperSlides: ".swiper-slide",
        pagination: ".hco-carousel__pagination",
        progress: ".progress",
      },
    };
  }
  getDefaultElements() {
    const selectors = this.getSettings("selectors");
    return {
      $swiperContainer: this.$element.find(selectors.swiperContainer),
      $swiperSlides: this.$element.find(selectors.swiperSlides),
      $pagination: this.$element.find(selectors.pagination),
      $progress: this.$element.find(selectors.progress),
    };
  }
  bindEvents() {}
}

/**
 * Register JS Handler for the Test Widget
 *
 * When Elementor frontend was initiated, and the widget is ready, register the widet
 * JS handler.
 */
window.addEventListener("elementor/frontend/init", () => {
  elementorFrontend.elementsHandler.attachHandler(
    "gravitas_countUpCarousel",
    CountUpCarousel
  );
});
